import React from 'react';
import { useDispatch } from 'react-redux';
import RoleService from '../Services/roleService';
import { navbutton_click, submenubutton_click } from '../redux/actions';
import { iconsEnabled } from '../Helpers/iconHelper';

// Flyout card listing a section's role-filtered submenu items.
// `section` is the menuitems entry; `sectionIndex` its index in menuitems.
export default function NavFlyout({
  section,
  sectionIndex,
  activeSub,
  isActiveSection,
  onClose,
  onNavigate,
  onMouseEnter,
  onMouseLeave,
}) {
  const dispatch = useDispatch();
  const submenu = section.submenu || [];

  const handleItemClick = (sub, subIndex) => {
    // navbutton_click first clears `menuitem` + sets the section; then
    // submenubutton_click sets the active sub and the content link.
    dispatch(navbutton_click(sectionIndex, section.link, section.text, section.linktext, section.icon, section.url));
    dispatch(
      submenubutton_click(subIndex, sub.link, sub.linktext ? sub.linktext : sub.text, sub.icon, sub.url, sectionIndex)
    );
    // Close the flyout (and, on mobile, the drawer) now that navigation happened.
    (onNavigate || onClose)();
  };

  return (
    <>
      <div
        className='flyout-catch'
        onClick={onClose}
      />
      <aside
        className='flyout'
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div className='flyout-head'>
          <div className='fh-txt'>
            <div className='eyebrow'>Navigation</div>
            <h3>{section.text}</h3>
          </div>
          <div className='sp' />
          <button
            type='button'
            className='fclose'
            onClick={onClose}
            aria-label='Close'
          >
            <i className='fa-solid fa-xmark' />
          </button>
        </div>
        <div className='flyout-list'>
          {submenu.map((sub, i) => {
            if (!RoleService.CheckUserPermission('submenu', sub.key)) return null;
            const active = isActiveSection && i === activeSub;
            return (
              <button
                type='button'
                key={`flyout-item-${i}`}
                className={`flyout-item${active ? ' active' : ''}`}
                onClick={() => handleItemClick(sub, i)}
              >
                {iconsEnabled() && <i className={sub.icon} />}
                <span>{sub.linktext ? sub.linktext : sub.text}</span>
              </button>
            );
          })}
        </div>
      </aside>
    </>
  );
}
